export function limpaMaskCelular(cell: string) {
  return cell
    .replaceAll("(", "")
    .replaceAll(")", "")
    .replaceAll("-", "")
    .replaceAll(" ", "");
}
